var index = {
  root: {
    borderRadius: '{content.border.radius}'
  }
};

export { index as default };
//# sourceMappingURL=index.mjs.map
